// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Price = require("../Price.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let PropertyPrice_price_graphql = require("../../../__generated__/PropertyPrice_price_graphql.bs.js");
let PropertyPrice_property_graphql = require("../../../__generated__/PropertyPrice_property_graphql.bs.js");
let PropertyPrice_propertyPrice_graphql = require("../../../__generated__/PropertyPrice_propertyPrice_graphql.bs.js");

let convertFragment = PropertyPrice_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPrice_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPrice_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPrice_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPrice_property_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyPrice_price_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPrice_price_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPrice_price_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPrice_price_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyPrice_price_graphql.node, convertFragment$1, fRef);
}

let PropertyPriceFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = PropertyPrice_propertyPrice_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPrice_propertyPrice_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPrice_propertyPrice_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPrice_propertyPrice_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyPrice_propertyPrice_graphql.node, convertFragment$2, fRef);
}

let PropertyPricePriceFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function PropertyPrice$PriceInternal$PriceDisplay(props) {
  let __children = props.children;
  let className = props.className;
  let size = props.size;
  let children = __children !== undefined ? __children : null;
  let propertyPrice = RescriptRelay_Fragment.useFragment(PropertyPrice_propertyPrice_graphql.node, convertFragment$2, props.propertyPrice);
  switch (propertyPrice.__typename) {
    case "ExactPrice" :
      return JsxRuntime.jsxs(Price.make, {
        children: [
          propertyPrice.price.formatted,
          children
        ],
        size: size,
        className: className
      });
    case "PriceRange" :
      return JsxRuntime.jsxs(Price.make, {
        children: [
          propertyPrice.minPrice.formatted,
          " - ",
          propertyPrice.maxPrice.formatted,
          children
        ],
        size: size,
        className: className
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected price: ` + propertyPrice._0);
  }
}

let PriceDisplay = {
  make: PropertyPrice$PriceInternal$PriceDisplay
};

function PropertyPrice$PriceInternal$Price(props) {
  let __children = props.children;
  let children = __children !== undefined ? __children : null;
  let property = RescriptRelay_Fragment.useFragment(PropertyPrice_price_graphql.node, convertFragment$1, props.property);
  return JsxRuntime.jsx(PropertyPrice$PriceInternal$PriceDisplay, {
    propertyPrice: property.price.fragmentRefs,
    size: props.size,
    className: props.className,
    children: children
  });
}

let Price$1 = {
  make: PropertyPrice$PriceInternal$Price
};

let PriceInternal = {
  PropertyPriceFragment: PropertyPriceFragment,
  PropertyPricePriceFragment: PropertyPricePriceFragment,
  PriceDisplay: PriceDisplay,
  Price: Price$1
};

function PropertyPrice$WithoutErrorBoundary(props) {
  let className = props.className;
  let size = props.size;
  let property = RescriptRelay_Fragment.useFragment(PropertyPrice_property_graphql.node, convertFragment, props.property);
  switch (property.__typename) {
    case "ForSalePropertyV5" :
      return JsxRuntime.jsx(PropertyPrice$PriceInternal$Price, {
        property: property.fragmentRefs,
        size: size,
        className: className
      });
    case "RentalPropertyV5" :
      return JsxRuntime.jsx(PropertyPrice$PriceInternal$Price, {
        property: property.fragmentRefs,
        size: size,
        className: className,
        children: "/month"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected member: ` + property._0);
  }
}

let WithoutErrorBoundary = {
  make: PropertyPrice$WithoutErrorBoundary
};

function PropertyPrice(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "price",
    children: JsxRuntime.jsx(PropertyPrice$WithoutErrorBoundary, {
      property: props.property,
      size: props.size,
      className: props.className
    })
  });
}

let Price$2;

let make = PropertyPrice;

exports.PropertyFragment = PropertyFragment;
exports.PriceInternal = PriceInternal;
exports.Price = Price$2;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Price Not a pure module */
